
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/work",
      function () {
        return require("private-next-pages/admin/work/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/work"])
      });
    }
  